import React, { FC, ReactNode, useState } from 'react';
import { classnames } from '@/utils/classnames';

interface IHamiBalanceSlideCardWrapperProps {
  children: ReactNode;
  isMelliCardAccountAlreadyCreated: boolean;
  dragSensitivity: number;
}

export const HamiBalanceSlideCardWrapper: FC<
  IHamiBalanceSlideCardWrapperProps
> = ({ children, isMelliCardAccountAlreadyCreated, dragSensitivity }) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startY, setStartY] = useState<number>(0);
  const [shouldFlip, setShouldFlip] = useState<boolean>(false);

  const handlePointerDown = (event: React.PointerEvent) => {
    setIsDragging(true);
    setStartY(event.clientY);
  };

  const handlePointerMove = (event: React.PointerEvent) => {
    if (!isDragging) return;

    const deltaY = event.clientY - startY;

    if (deltaY < dragSensitivity) {
      setShouldFlip(!shouldFlip);
      setIsDragging(false);
    }
  };

  const handlePointerUp = () => {
    setIsDragging(false);
  };

  const pointerEvents = isMelliCardAccountAlreadyCreated
    ? {
        onPointerDown: handlePointerDown,
        onPointerMove: handlePointerMove,
        onPointerUp: handlePointerUp,
      }
    : {};

  return (
    <div
      className={classnames(
        'relative z-20 h-[160px] w-full transition-transform duration-700 transform-3d',
        shouldFlip && '[transform:rotateX(180deg)]'
      )}
      {...pointerEvents}
    >
      {children}
    </div>
  );
};
